




















import { Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper from '@/services/helper';
import Q from 'q';
import api from '@/services/api';

@Component({
  computed: {
    ...mapState({
      Lang: 'Lang',
    }),
  },
})
export default class LocalesSwitcher extends VueBase {
  public readonly Lang!: string;

  get locales() {
    if (process.env.VUE_APP_CLIENT == 'kantar') {
      return locales.filter((x) => x.twoLetter != 'en');
    }
    return locales;
  }

  @Prop({ default: false })
  public readonly compact!: boolean;

  @Prop({ default: true })
  public readonly showHint!: boolean;

  get ActiveLocale() {
    return this.locales.find((x) => x.name == this.Lang);
  }

  async ChangeLang(lang: string) {
    helper.swalShowLoading();
    let delayPromise = Q.delay(1000);
    let resp = await api.SetLanguage(lang);
    await delayPromise;
    window.location.reload();
  }

  public openLanguageModal() {
    this.$modal.show('locale-switcher');
  }
}
